export default __webpack_public_path__ + "static/xr_glasses-ce710c5021084d929c81e0eabe084799.png";